import { Record } from 'immutable';

export default class MerchantRecord extends Record({
  id: null,
  platform: '',
  name: '',
  supports_standalone_csr: null,
  support_email: '',
  active_promo: {},
  public_key: '',
  url: '',
  restricted_industry: null,
  slug: '',
  default_checkout_method: null
}) {
}
